import type {
  ProductDefinition,
  ProductPriceApiItem,
} from "../types/productTypes";

export const slugifyProductTitle = (title: string): string => {
  return title.replaceAll(" ", "-").toLowerCase();
};

export const formatProductPrice = (price: number) => {
  const [integerPart, decimalPart] = price.toFixed(2).split(".");

  return {
    price: integerPart,
    decimalPrice: decimalPart,
  };
};

export const mergeProductsWithPrices = (
  products: ProductDefinition[],
  priceItems: ProductPriceApiItem[]
): ProductDefinition[] => {
  return products.map((product) => {
    const priceItem = priceItems.find(
      (item) => String(item.codigo_plano) === String(product.id)
    );

    if (!priceItem) {
      return product;
    }

    const { price, decimalPrice } = formatProductPrice(
      priceItem.valor_preco_base
    );

    return {
      ...product,
      fullPrice: priceItem.valor_preco_base,
      price,
      decimalPrice,
      iof: priceItem.aliquota_iof,
    };
  });
};

export const getProductById = (
  products: ProductDefinition[],
  productId: string | number
): ProductDefinition => {
  return (
    products.find((product) => String(product.id) === String(productId)) ??
    products[0]
  );
};